var render = function render(){var _vm=this,_c=_vm._self._c;return _c('viewer-svg',{attrs:{"svg":_vm.svg,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }